import debug from 'debug';
import InspirationCatalogs from '../inspiration-catalogs/inspiration-catalogs';
import Querystring from 'Minetilbud/Shared/Components/Querystring/Querystring';
import CatalogsByQuery from './data/catalogs-by-query';
import Render from './render/render';

const log = debug('InspirationCatalogsByQuery');

class InspirationCatalogsByQuery extends InspirationCatalogs {
	constructor(element) {
		super(element);
	}

	async getCatalogs() {
		if (this.catalogs !== undefined) return this.catalogs;

		if (this.isFollowingRuns === true) return [];
		this.isFollowingRuns = true;

		try {
			const searchQuery = this.parseQuery(this.settings);
			const catalogsByQuery = new CatalogsByQuery();
			const catalogs = await catalogsByQuery.get(searchQuery);
			log('getCatalogs()', catalogs);
	
			this.catalogs = catalogs;
			return catalogs;
		} catch (error) {
			log('getCatalogs() - ERROR', error);
		}
	}

	parseQuery(query) {
		const querystring = new Querystring();
		return querystring.ObjToQuerystring(query);
	}

	ready() {
		if (this.render !== undefined) return;
		this.render = new Render(this.dom.list, this.catalogs);
	}
}

export default InspirationCatalogsByQuery;
